import React from 'react';
import Tag from '@amzn/meridian/tag';
import { getStatusTagType } from '../dashboard/utils';
import { getStatusGlyph, getStatusLabel } from './utils';

export interface StatusBadgeProps {
    /** Server-computed ComparisonStatus. The 5%/15% bands are already applied upstream. */
    status: string | undefined;
    'data-testid'?: string;
}

/**
 * The one way health is shown on the Visual Flow Map.
 *
 * Colour comes from the shared `getStatusTagType` (AHEAD/ON_TRACK → green, AT_RISK →
 * amber, CRITICAL → red) but is never the only signal: the badge always carries a text
 * label and a distinct glyph, so the view stays readable for colour-blind operators and
 * in greyscale.
 *
 * Meridian's `Tag` takes a single string child, so the glyph and label are one string
 * rather than separate elements. `aria-label` then pins the announced name to the plain
 * label, keeping the glyph a purely visual cue instead of something a screen reader
 * spells out.
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({ status, 'data-testid': testId }) => {
    const label = getStatusLabel(status);
    return (
        <Tag type={getStatusTagType(status)} data-testid={testId} aria-label={label}>
            {`${getStatusGlyph(status)} ${label}`}
        </Tag>
    );
};

export default StatusBadge;
